import { Outlet, Navigate } from 'react-router-dom';
import { hasAdminUser } from '../../utils/users';

export const AdminRouter = () => {
	const hasAdmin = !!hasAdminUser();
	return hasAdmin ? <Outlet /> : <Navigate to='/historico' />;
};
